import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "Shion Ideals": "Shion Ideals",
      Home: "Home",
      "About Us": "About Us",
      Services: "Services",
      "Contact Us": "Contact Us",
      Language: "Language",
      StayConnected:"Stay Connected...",
      Havesomeissues:"Have some issues? ",
      welcomecontact:"Welcome to Shion Ideals, your trusted partner in high-quality spare parts, vehicle, and machinery supplies. We are here to assist you with all your inquiries, product availability, and order details. Please feel free to reach out to us using our contact information!",
      generalEnquiries:"General Enquiries",
      ShionIdeals:"Shion Ideals",
      firstintro:"Driving Excellence with Vehicles, Machinery, and Spare Parts Under One Roof..",
      ViewMore:"View More",
      InnovativeSolutions:"Innovative Solutions",
      Deliveringthe:"Delivering the Best Spare Parts Worldwide",
      Trustedby:"Trusted by Thousands",
      Sustainable:"Sustainable and Reliable Products",
      AboutUs:"About Us",
      WelcometoShionIdeals:"Welcome to Shion Ideals, where quality meets affordability. Based in Japan, we specialize in providing original Japanese vehicles, machinery, and spare parts, offering an all-in-one solution to meet your needs. With our unwavering commitment to precision and innovation, we deliver products that are not only reliable but designed to excel in demanding industries. Our team of experts ensures that every product embodies the hallmark of Japanese craftsmanship—durability, efficiency, and meticulous attention to detail. Whether you're in the automotive, industrial, or other sectors, Shion Ideals is your trusted partner for top-tier spare parts at competitive prices. We are dedicated to helping businesses and individuals succeed with the best products, all while maintaining affordability.",
      OurVision:"Our Vision",
      Tobeatrustedleader:"To be a trusted leader in vehicles, machinery, and spare parts by setting new benchmarks for quality, innovation, and customer satisfaction.",
      NewBeginnings:"New Beginnings",
      Redefininginnovation:"Redefining innovation with optimism.",
      TeamSpirit:"Team Spirit",
      Fostering:"Fostering collaboration and inclusiveness.",
      CalmApproach:"Calm Approach",
      Maintaining:"Maintaining focus and tranquility.",
      OurMission:"Our Mission",
      Toprovideexceptional:"To provide exceptional products and services that empower our customers to excel, driven by our commitment to precision, reliability, and sustainability in everything we do.",
      Teamwork:"Teamwork",
      Fosteringinclusiveteamwork:"Fostering inclusive teamwork.",
      Sustainability:"Sustainability",
      Promotingeco:"Promoting eco-conscious practices.",
      Education:"Education",
      Educating:"Educating for a green future.",
      OurServices:"Our Services",
      Explorethediverse:"Explore the diverse range of services we offer, tailored to meet your unique needs and goals.",
      QualityAssurance:"Quality Assurance",
      Weensureevery:"We ensure every product meets the highest quality standards.",
      WideRangeofProducts:"Wide Range of Products",
      Choosefrom:"Choose from a diverse selection of spare parts.",
      CustomerSupport:"24/7 Customer Support",
      Ourteamis:"Our team is always ready to assist you.",
      OurBrands:"Our Brands",
      Followus:"Follow Us",
      Allrightsreserved:"© 2024 ShionIdeals. All rights reserved",
      Facebook:"Facebook",
      Twitter:"Twitter",
      Instagram:"Instagram",
       postalAddress: "📍 Postal Code: 511-0101 MIE KEN, KUWANA SHI, TADO CHO, Yui, 1233-2 1F"






    },
  },
  jp: {
    translation: {
      "Shion Ideals": "シオンアイデアル",
      Home: "ホーム",
      "About Us": "私たちについて",
      Services: "サービス",
      "Contact Us": "お問い合わせ",
      Language: "言語",
      StayConnected:"接続を保つ...",
      Havesomeissues:"いくつかの問題がありますか？",
      welcomecontact:"シオンアイデアルズへようこそ。高品質な部品、車両、機械供給の信頼できるパートナーです。ご質問、製品の在庫、注文の詳細について、いつでもお問い合わせください。連絡先情報を使用してお気軽にご連絡ください！",
      generalEnquiries:"一般的なお問い合わせ",
      ShionIdeals:"シオン・アイディアルズ",
      firstintro:" 車両、機械、そして部品を一つの屋根の下で提供し、卓越性を追求します",
      ViewMore:"詳しく見る",
      InnovativeSolutions:"革新的なソリューション",
      Deliveringthe:"世界中に最高の部品をお届けします。",
      Trustedby:"数千人に信頼されています",
      Sustainable:"持続可能で信頼性の高い製品",
      AboutUs:"会社概要",
      WelcometoShionIdeals:"シオン・アイディアルズへようこそ。ここでは、品質と手頃な価格が融合しています。私たちは日本を拠点に、オリジナルの日本製車両、機械、そして部品を提供し、すべてを一括で解決するソリューションを提供しています。正確さと革新性への揺るぎないコミットメントにより、信頼性が高く、要求の厳しい産業で活躍できる製品をお届けします。専門家チームが日本の職人技の象徴である耐久性、効率性、細部へのこだわりをすべての製品に込めています。自動車、産業、その他の分野において、シオン・アイディアルズは競争力のある価格で高品質な部品を提供する信頼のパートナーです。",
      OurVision:"ビジョン",
      Tobeatrustedleader:"車両、機械、そして部品の分野で信頼されるリーダーとなり、品質、革新性、そして顧客満足の新たな基準を設定します。",
      NewBeginnings:"新たな始まり",
      Redefininginnovation:"楽観的な視点で革新を再定義します。",
      TeamSpirit:"チームスピリット",
      Fostering:" 協力と包摂性を育む",
      CalmApproach:"落ち着いたアプローチ",
      Maintaining:"集中力と静けさを保つ",
      OurMission:"ミッション",
      Toprovideexceptional:"精度、信頼性、持続可能性に基づいて、顧客が成功を収められる優れた製品とサービスを提供します。",
      Teamwork:"チームワーク",
      Fosteringinclusiveteamwork:" 包摂的なチームワークを育む",
      Sustainability:"持続可能性",
      Promotingeco:"環境意識のある実践を促進する",
      Education:"教育",
      Educating:"持続可能な未来のための教育",
      OurServices:"サービス内容",
      Explorethediverse:"多様なニーズと目標に応じた幅広いサービスをご覧ください。",
      QualityAssurance:"品質保証",
      Weensureevery:"すべての製品が最高の品質基準を満たすよう保証します。",
      WideRangeofProducts:"幅広い製品ラインナップ",
      Choosefrom:"多様な部品の中からお選びください。",
      CustomerSupport:"24時間365日カスタマーサポート",
      Ourteamis:"当チームはいつでもお客様のサポートに対応します。",
      OurBrands:"ブランド",
      Followus: "フォローする",
      Allrightsreserved: "© 2024 ShionIdeals. 無断転載禁止",
      Facebook: "フェイスブック",
      Twitter: "ツイッター",
      Instagram: "インスタグラム",
       postalAddress: "〒 511-0101,三重県桑名市多度町柚井１２３３番地２、１階"

  
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "en", // Load saved language or default to English
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
